import { jsx as _jsx } from "react/jsx-runtime";
import { ChakraProvider } from '@chakra-ui/react';
import { theme } from './theme';
/**
 * The global provider that must be added to make all components in this design
 * system work correctly
 */
export const ThemeProvider = (props) => (_jsx(ChakraProvider, { portalZIndex: 40, theme: theme, ...props }));
